import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ReBaseData } from '../../../shared/utils/re-base-data';
import { MaintenanceService } from '../../services/maintenance.service';

@Component({
    selector: 'bdo-maintenance-warning',
    templateUrl: './maintenance-warning.component.html',
    styleUrls: ['./maintenance-warning.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaintenanceWarningComponent {
  @Input() soonUnderMaintenance: boolean;
  @Input() infoText: string;
  @Input() start: Date;
  @Input() end: Date;
  public maintenanceShowPopup$ = this.maintenanceService.showPopup$;
  public serviceUnavailable$ = this.maintenanceService.serviceUnavailable$;
  protected reBaseData = ReBaseData;

  constructor(
    private maintenanceService: MaintenanceService
  ) { }

  close() {
    if (this.soonUnderMaintenance) {
      this.maintenanceService.closeMaintenancePopup();
    } else {
      window.location.href = ReBaseData.hrefContactForm;
    }
  }

}
